<template>
  <b-container>
      <!-- Componente -->
  </b-container>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/componentes/componentInBlank.vue